/* global Phaser, CocoonJS, window, social, localstorage */

// Initialize Phaser
// iphone portrait = 375 x 667
// iphone portrait = 667 x 375

var game = new Phaser.Game( 64, 64, Phaser.CANVAS, 'game-canvas', null, false, false );

// Define states
game.state.add( 'boot', bootState );
game.state.add( 'load', loadState );
game.state.add( 'menu', menuState );
game.state.add( 'play', playState );

// Start the "boot" state
game.state.start( 'boot' );
